import {
  VirtualSupportCard,
  ServiceOrdersCard,
  SpeedTestCard,
  PasswordChange,
  WifiCard,
  FaqCard,
  StoreCard,
  NegotiationCard,
  AccountUnlockCard,
  DigitalServicesCard,
  DueDateChange,
  FileSendCard,
} from 'pages/dashboard/components/cards/components'

export const DASHBOARD_LEFT_CARDS = [
  StoreCard,
  ServiceOrdersCard,
  SpeedTestCard,
  PasswordChange,
  WifiCard,
  FaqCard,
]

export const DASHBOARD_RIGHT_CARDS = [
  VirtualSupportCard,
  NegotiationCard,
  AccountUnlockCard,
  DigitalServicesCard,
  DueDateChange,
  FileSendCard,
]
